<template>
  <v-img
    class="avatar"
    v-if="img"
    :src="apiDomain + '/min/' + img"
    :height="size"
    :width="size"
    alt=""
  >
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate color="#277faf"></v-progress-circular>
      </v-row>
    </template>
  </v-img>
  <div
    v-else
    class="avatar noPhoto"
    :style="{
      width: size ? size + 'px' : '',
      height: size ? size + 'px' : '',
    }"
  >
    <Employee class="icon" />
    <span
      class="initials text-uppercase"
      :style="{
        fontSize: size ? size / 3 + 'px' : '',
      }"
      >{{ textFirst && textSecond ? textSecond.charAt(0) + textFirst.charAt(0) : '—' }}</span
    >
  </div>
</template>

<script>
import Employee from 'components/icons/employees/Employee'
export default {
  name: 'EmployeesPhoto',
  props: ['size', 'img', 'textFirst', 'textSecond'],
  components: {
    Employee,
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  border-radius: 50%;
  &.noPhoto {
    background-color: #277faf;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 30% auto;
    grid-row-gap: 2%;
    position: relative;
    align-content: center;
    justify-content: center;
    justify-items: center;

    .initials {
      font-weight: bold;
      line-height: 1;
      color: #ffffff;
    }
    .icon {
      width: auto;
      height: 100%;
      margin: 0 !important;
    }
  }
}
</style>
